import React from 'react';
import { ITEM_DATABASE } from '../../../../shared/content/generated/items.gen';
import { ItemIcon } from '../../components/ItemIcon';
import { Tooltip, createItemTooltip, type ItemTooltipViewerContext } from '../../components/Tooltip';
import { craftingItemName } from './InventoryPresentation';

/** One item on a recipe folio: the shared icon and tooltip, its name, quantity and an optional caption. */
export function CraftingItem({ itemId, quantity, viewer, caption, children }: {
  itemId: string; quantity: number; viewer?: ItemTooltipViewerContext; caption?: React.ReactNode; children?: React.ReactNode;
}): React.ReactElement {
  const item = ITEM_DATABASE[itemId];
  const name = craftingItemName(itemId);
  const tooltip = createItemTooltip({ id: itemId, name, quantity }, viewer);
  return <div className="crafting-tome__item" data-item-known={item ? 'true' : 'false'}>
    <Tooltip data={tooltip}><span className="crafting-tome__item-art" tabIndex={0} aria-label={`${name} item details`}>
      {item ? <ItemIcon itemId={itemId} size={36} /> : <span aria-label="Artwork unavailable">?</span>}
    </span></Tooltip>
    <div className="crafting-tome__item-text">
      <div className="crafting-tome__item-line"><strong>{name}</strong><span className="crafting-tome__qty">×{quantity}</span></div>
      {caption}
      {children}
    </div>
  </div>;
}
